import { useAppSelector } from '../../app/hooks';
import { VISIBILITY_KEYS } from '../../utils/constants/visibilityKeys';
import { useVisibilityConfig } from '../../utils/useVisibilityConfig';
import { isFailClosedPnoGateOpen } from '../../utils/visibilityConfigUtils';
import { getUserDataFromStorage, isPnoUser } from '../../utils/utils';

/** The shared fail-closed config gate: enabled === 1 and the pnoIdEcho matches the caller's PNO. */
export const useCreditsDashboardGate = (): boolean => {
    const { config: visibilityConfig } = useVisibilityConfig();
    const investorOrgId = useAppSelector((state) => state.user.userData?.investorOrgId);
    return isFailClosedPnoGateOpen(
        visibilityConfig,
        VISIBILITY_KEYS.CREDITS.DASHBOARD_ENABLED,
        VISIBILITY_KEYS.CREDITS.DASHBOARD_PNO_ECHO,
        investorOrgId,
    );
};

/** Credits are for PNO users only (INVESTOR + ADMIN_TEAM) — never partner/lender users of the same PNO. */
export const useCreditsEntitlement = (): boolean => {
    const gateOpen = useCreditsDashboardGate();
    return isPnoUser(getUserDataFromStorage()?.accountType) && gateOpen;
};
